(function () {
  const params = new URLSearchParams(window.location.search);
  const hash = window.location.hash;
  if (
    params.get('contact_posted') === 'true' &&
    (hash.includes('ApplyModalForm') || hash.includes('ApplyPageForm'))
  ) {
    window.location.replace('/pages/apply-thank-you');
  }
})();

class ApplyFormModal extends HTMLElement {
  constructor() {
    super();
    this.triggerElement = null;
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onTrapFocus = this.onTrapFocus.bind(this);
  }

  connectedCallback() {
    this.container = this.querySelector('.apply-modal__container');

    this.querySelectorAll('[data-modal-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key === 'Tab') {
      this.onTrapFocus(event);
    }
  }

  getFocusableElements() {
    const selectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    return Array.from((this.container || this).querySelectorAll(selectors)).filter(
      (el) => el.offsetParent !== null
    );
  }

  onTrapFocus(event) {
    const focusable = this.getFocusableElements();
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  open(triggerElement) {
    this.triggerElement = triggerElement || document.activeElement;

    this.setAttribute('aria-hidden', 'false');
    this.classList.add('apply-modal--open');
    document.body.style.overflow = 'hidden';

    document.addEventListener('keydown', this.onKeyDown);

    const firstInput = this.querySelector('input, select, textarea');
    if (firstInput) {
      firstInput.focus();
    } else if (this.container) {
      this.container.focus();
    }
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    this.classList.remove('apply-modal--open');
    document.body.style.overflow = '';

    document.removeEventListener('keydown', this.onKeyDown);

    if (this.triggerElement && typeof this.triggerElement.focus === 'function') {
      this.triggerElement.focus();
    }
    this.triggerElement = null;
  }
}

customElements.define('apply-form-modal', ApplyFormModal);

function openApplyModal() {
  const modal = document.querySelector('apply-form-modal');
  if (modal) {
    modal.open(document.activeElement);
  }
}
